/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useEquipeUsuario(idUsuario: string, enabled?: boolean) {
  const fetchData = async () => {
    if (idUsuario === undefined) {
      return;
    }
    const url = `identity/admin/hierarquias/equipe-por-usuario/v1/${idUsuario}`;
    const response = await instance.get(url);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: async () => await fetchData(),
    queryKey: ["equipeusuario"],
    refetchOnWindowFocus: false,
    enabled: enabled === undefined ? true : enabled,
  });
  return query;
}
